import { AnalysisPage } from "../../pages/AnalysisPage.jsx";
import { BudgetPage } from "../../pages/BudgetPage.jsx";
import { DevPage } from "../../pages/DevPage.jsx";
import { DevProjectionFormulaPage } from "../../pages/DevProjectionFormulaPage.jsx";
import { ExpensesPage } from "../../pages/ExpensesPage.jsx";
import { HelpPage } from "../../pages/HelpPage.jsx";
import { HomePage } from "../../pages/HomePage.jsx";
import { SettingsPage } from "../../pages/SettingsPage.jsx";

export function AppContent({
  activeLanguage,
  appSettings,
  budgetPage,
  budgetDraftEntryRequest,
  budgetScope,
  currentPage,
  currentSections,
  dateContext,
  expenseRows,
  handleAnalysisBudgetReviewFilterChange,
  handleAnalysisChartsMetricChange,
  handleAnalysisExplorerPresetChange,
  handleBudgetRowsChange,
  handleBudgetViewModeChange,
  handleCurrencyChange,
  handleDataImported,
  handleExpensesChanged,
  handleExpensesVisibilityFilterChange,
  handleHomeTileConfigsChange,
  handleImportPreviousYearBudget,
  handleLanguageChange,
  handleScopeChanged,
  handleLoadSampleData,
  handleStartBudgetEntry,
  hasPreviousYearBudgetRows = false,
  handleThemeChange,
  getTranslationNode = () => null,
  isBudgetReady,
  navigateToPage,
  navigateToSection,
  profileSettings,
  showAltHints,
  t = (key) => key
}) {
  const isRtl = activeLanguage === "he";

  function navigateToContextPage(pageKey, sectionKey = null) {
    navigateToPage(pageKey, sectionKey, { contextual: true });
  }

  if (currentPage === "home") {
    return (
      <HomePage
        activeLanguage={activeLanguage}
        budgetPage={budgetPage}
        dateContext={dateContext}
        isRtl={isRtl}
        navigateToPage={navigateToPage}
        onExpensesVisibilityFilterChange={handleExpensesVisibilityFilterChange}
        tileConfigs={profileSettings.home.tiles}
        onTileConfigsChange={handleHomeTileConfigsChange}
        t={t}
      />
    );
  }

  if (currentPage === "expenses") {
    return (
      <ExpensesPage
        activeScope={budgetScope}
        onNavigateToPage={navigateToContextPage}
        onExpensesChanged={handleExpensesChanged}
        onLoadSampleData={handleLoadSampleData}
        onStartBudgetEntry={handleStartBudgetEntry}
        visibilityFilter={profileSettings.expenses.visibilityFilter}
        onVisibilityFilterChange={handleExpensesVisibilityFilterChange}
        showAltHints={showAltHints}
        t={t}
      />
    );
  }

  if (currentPage === "budget") {
    return isBudgetReady ? (
      <BudgetPage
        page={budgetPage}
        dateContext={dateContext}
        budgetDraftEntryRequest={budgetDraftEntryRequest}
        onNavigateToPage={navigateToContextPage}
        onRowsChange={handleBudgetRowsChange}
        onLoadSampleData={handleLoadSampleData}
        onImportPreviousYearBudget={handleImportPreviousYearBudget}
        onStartBudgetEntry={handleStartBudgetEntry}
        hasPreviousYearBudgetRows={hasPreviousYearBudgetRows}
        detailMode={profileSettings.budget.viewMode}
        onDetailModeChange={handleBudgetViewModeChange}
        showAltHints={showAltHints}
        t={t}
      />
    ) : null;
  }

  if (currentPage === "help") {
    return (
      <HelpPage
        activeSection={currentSections.help}
        getTranslationNode={getTranslationNode}
        onSectionChange={(sectionKey) => navigateToSection("help", sectionKey)}
        showAltHints={showAltHints}
        t={t}
        activeLanguage={activeLanguage}
      />
    );
  }

  if (currentPage === "analysis") {
    return (
      <AnalysisPage
        activeSection={currentSections.analysis}
        onSectionChange={(sectionKey) => navigateToSection("analysis", sectionKey)}
        onNavigateToPage={navigateToContextPage}
        rows={budgetPage.rows}
        expenseRows={expenseRows}
        dateContext={dateContext}
        profileSettings={profileSettings}
        onExplorerPresetChange={handleAnalysisExplorerPresetChange}
        onChartsMetricChange={handleAnalysisChartsMetricChange}
        onBudgetReviewFilterChange={handleAnalysisBudgetReviewFilterChange}
        showAltHints={showAltHints}
        t={t}
      />
    );
  }

  if (currentPage === "settings") {
    return (
      <SettingsPage
        onDataImported={handleDataImported}
        onScopeChanged={handleScopeChanged}
        activeScope={budgetScope}
        appSettings={appSettings}
        profileSettings={profileSettings}
        activeSection={currentSections.settings}
        onSectionChange={(sectionKey) => navigateToSection("settings", sectionKey)}
        onThemeChange={handleThemeChange}
        onLanguageChange={handleLanguageChange}
        onCurrencyChange={handleCurrencyChange}
        showAltHints={showAltHints}
        t={t}
      />
    );
  }

  if (currentPage === "dev") {
    if (currentSections.dev === "projection-formula") {
      return (
        <DevProjectionFormulaPage
          budgetRows={budgetPage.rows}
          expenseRows={expenseRows}
          dateContext={dateContext}
          t={t}
        />
      );
    }

    return (
      <DevPage
        onNavigateToPage={navigateToPage}
      />
    );
  }

  return null;
}
